exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap);", ""]);

// module
exports.push([module.id, ".modal.bottom-sheet {\n    max-height: 75%;\n}\np{\n    font-family: 'Roboto', sans-serif;\n    font-size: 24px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/apicall/apicall.component.css
// module id = ../../../../../src/app/_components/components_user/apicall/apicall.component.css
// module chunks = main